(function () {
  'use strict';
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var formatString = format || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    var value = '';
    var match = formatString.match(placeholderRegex);
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  var SHOW_AFTER_SCROLL = 200;

  class ProductStickyCart extends HTMLElement {
    connectedCallback() {

      this.addButton = this.querySelector('[data-sticky-add]');
      this.addText = this.querySelector('[data-sticky-add-text]');
      this.qtyInput = this.querySelector('[data-sticky-qty]');
      this.priceCurrent = this.querySelector('[data-sticky-price-current]');
      this.priceCompare = this.querySelector('[data-sticky-price-compare]');
      this.mediaWrapper = this.querySelector('[data-sticky-image]');

      this.variantsWrapper = this.querySelector('[data-sticky-variants]');

      this._onAdd = this._onAdd || this.handleAdd.bind(this);
      this._onVariantChanged = this._onVariantChanged || this.handleVariantChanged.bind(this);
      this._onSectionLoad = this._onSectionLoad || this.handleSectionLoad.bind(this);
      this._onOptionChange = this._onOptionChange || this.handleOptionChange.bind(this);

      if (this.addButton) this.addButton.addEventListener('click', this._onAdd);
      if (this.variantsWrapper) {
        this.variantsWrapper.addEventListener('change', this._onOptionChange);
      }
      document.addEventListener('product:variant-changed', this._onVariantChanged);
      document.addEventListener('shopify:section:load', this._onSectionLoad);

      this.syncButtonHeight();
      this.setup();
    }

   
    syncButtonHeight() {
      if (!('ResizeObserver' in window) || !this.addButton) return;
      var self = this;
      var apply = function () {
        if (self.addButton.offsetHeight === 0) return;
        self.style.setProperty('--sticky-atc-height', self.addButton.offsetHeight + 'px');
      };
      apply();
      this._heightObserver = new ResizeObserver(apply);
      this._heightObserver.observe(this.addButton);
    }

    disconnectedCallback() {
      if (this.addButton) this.addButton.removeEventListener('click', this._onAdd);
      if (this.variantsWrapper) {
        this.variantsWrapper.removeEventListener('change', this._onOptionChange);
      }
      document.removeEventListener('product:variant-changed', this._onVariantChanged);
      document.removeEventListener('shopify:section:load', this._onSectionLoad);
      this.teardownObservers();
    }

    teardownObservers() {
      if (this._intersectionObserver) {
        this._intersectionObserver.disconnect();
        this._intersectionObserver = null;
      }
      if (this._onScroll) {
        window.removeEventListener('scroll', this._onScroll);
      }
      if (this._scrollFrame) {
        cancelAnimationFrame(this._scrollFrame);
        this._scrollFrame = null;
      }
      if (this._stateObserver) {
        this._stateObserver.disconnect();
        this._stateObserver = null;
      }
      if (this._errorObserver) {
        this._errorObserver.disconnect();
        this._errorObserver = null;
      }
      if (this._heightObserver) {
        this._heightObserver.disconnect();
        this._heightObserver = null;
      }
    }

    
    get scope() {
      return document.querySelector(
        'main-product[data-section-id="' + this.dataset.sectionId + '"]'
      );
    }

     
    get mainForm() {
      return document.getElementById('product-form-' + this.dataset.sectionId);
    }

    get mainAddButton() {
      var form = this.mainForm;
      return form ? form.querySelector('button[name="add"]') : null;
    }

    get mainBuyArea() {
      var form = this.mainForm;
      if (!form) return null;
      return form.closest('[data-buy-buttons]') || form;
    }

    get anchorElement() {
      return this.mainAddButton || this.mainBuyArea;
    }

    get variantPicker() {
      var scope = this.scope;
      return scope ? scope.querySelector('variant-picker') : null;
    }

    get stickyForm() {
      return this.querySelector('.product-sticky-cart__form');
    }

    get stickyVariantIdInput() {
      return this.querySelector('[data-sticky-variant-id]');
    }

    setup() {
      this.teardownObservers();

      var mainAdd = this.mainAddButton;
      var anchor = this.anchorElement;

      this.hide();

     
      this._anchorVisible = !!anchor;

      if (anchor) {
        this.observeVisibility(anchor);
      } else {
        this.attachScrollListener();
      }

      if (mainAdd) {
        this.observeButtonState(mainAdd);
        this.syncFromButton(mainAdd);
      }


      var self = this;
      setTimeout(function () {
        self.evaluateVisibility();
      }, 500);
    }

    observeVisibility(anchor) {
      var self = this;


      this._intersectionObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            self._anchorVisible = entry.isIntersecting;
            self.evaluateVisibility();
          });
        },
        {
          rootMargin: '0px',
          threshold: 0
        }
      );
      this._intersectionObserver.observe(anchor);

      this.attachScrollListener();
    }

    attachScrollListener() {
      var self = this;
      this._onScroll =
        this._onScroll ||
        function () {
          if (self._scrollFrame) return;
          self._scrollFrame = requestAnimationFrame(function () {
            self._scrollFrame = null;
            self.evaluateVisibility();
          });
        };
      window.addEventListener('scroll', this._onScroll, { passive: true });
    }

    evaluateVisibility() {
      var scrolledEnough = window.scrollY > SHOW_AFTER_SCROLL;
      var shouldShow = !this._anchorVisible && scrolledEnough;

      if (shouldShow) {
        this.show();
      } else {
        this.hide();
      }
    }

    show() {
      this.hidden = false; 
      void this.offsetHeight;
      this.classList.add('product-sticky-cart--visible');
    }

    hide() {
      this.hidden = true;
      this.classList.remove('product-sticky-cart--visible');
    }

    observeButtonState(mainAdd) {
      var self = this;
      this._stateObserver = new MutationObserver(function () {
        self.syncFromButton(mainAdd);
      });
      this._stateObserver.observe(mainAdd, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-busy'],
      });
    }

    syncFromButton(mainAdd) {
      if (!this.addButton || !mainAdd) return;
      this.addButton.disabled = mainAdd.disabled;
      if (mainAdd.hasAttribute('aria-busy')) {
        this.addButton.setAttribute('aria-busy', 'true');
      } else {
        this.addButton.removeAttribute('aria-busy');
      }

      var mainText = mainAdd.querySelector('[data-add-to-cart-text]');
      if (mainText && this.addText) {
        this.addText.textContent = mainText.textContent.trim();
      }
    }

    handleAdd() {
      var form = this.mainForm;
      var mainAdd = this.mainAddButton;

      if (!form) { 
        var fallbackForm = this.stickyForm;
        if (!fallbackForm) {
          this.showUnavailable();
          return;
        }
        if (this.addButton && this.addButton.disabled) return;
        fallbackForm.requestSubmit();
        return;
      }
      if (mainAdd ? mainAdd.disabled : this.addButton && this.addButton.disabled) return;

      var formQty = form.elements ? form.elements.quantity : null;
      if (this.qtyInput && formQty) formQty.value = this.qtyInput.value;

      var scope = this.scope;
      if (scope) this.watchForError(scope);

      if (mainAdd) form.requestSubmit(mainAdd);
      else form.requestSubmit();
    }

    showUnavailable() {
      if (!this.addButton) return;
      this.addButton.disabled = true;
      if (this.addText) {
        this.addText.textContent = this.addButton.dataset.textUnavailable || '';
      }
    }

    
    handleOptionChange(event) {
      var select = event.target.closest('[data-sticky-option-index]');
      if (!select) return;

      var picker = this.variantPicker;
      if (!picker) return;

      var index = select.dataset.stickyOptionIndex;
      var target = picker.querySelector('select[data-option-index="' + index + '"]');

      if (target) {
        target.value = select.value;
      } else { 
        var radios = picker.querySelectorAll(
          'input[type="radio"][data-option-index="' + index + '"]'
        );
        target = Array.prototype.find.call(radios, function (radio) {
          return radio.value === select.value;
        });
        if (!target) return;
        target.checked = true;
      }

      target.dispatchEvent(new Event('change', { bubbles: true }));
    }

    syncOptions(options) {
      if (!this.variantsWrapper || !options) return;
      this.variantsWrapper
        .querySelectorAll('[data-sticky-option-index]')
        .forEach(function (select) {
          var value = options[parseInt(select.dataset.stickyOptionIndex, 10)];
          if (value != null) select.value = value;
        });
    }

    watchForError(scope) {
      if (this._errorObserver) {
        this._errorObserver.disconnect();
        this._errorObserver = null;
      }

      var errorEl = scope.querySelector('[data-buy-buttons-error]');
      if (!errorEl) return;

      var self = this;
      this._errorObserver = new MutationObserver(function () {
        if (errorEl.hidden) return;
        errorEl.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'auto'
            : 'smooth',
          block: 'center',
        });
        self._errorObserver.disconnect();
        self._errorObserver = null;
      });
      this._errorObserver.observe(errorEl, {
        attributes: true,
        attributeFilter: ['hidden'],
      });
    }

    handleVariantChanged(event) {
      var detail = event.detail || {};
      if (String(detail.sectionId) !== String(this.dataset.sectionId)) return;

      var variant = detail.variant;
      this.syncOptions(detail.options);
      this.updatePrice(variant);
      this.updateImage(variant);
      this.updateAddButton(variant);

      var stickyIdInput = this.stickyVariantIdInput;
      if (stickyIdInput && variant) stickyIdInput.value = variant.id;
    }

    updatePrice(variant) {
      if (!this.priceCurrent) return;
      var format = this.dataset.moneyFormat;

      if (!variant) {
        this.priceCurrent.textContent = '';
        if (this.priceCompare) this.priceCompare.hidden = true;
        return;
      }

      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      this.priceCurrent.textContent = formatMoney(variant.price, format);

      if (this.priceCompare) {
        this.priceCompare.hidden = !onSale;
        this.priceCompare.textContent = onSale
          ? formatMoney(variant.compare_at_price, format)
          : '';
      }
    }

    updateImage(variant) {
      if (!this.mediaWrapper || !variant || !variant.featured_media_id) return;

      var scope = this.scope;
      if (!scope) return;

      var source = scope.querySelector(
        '.product-media-item[data-media-id="' + variant.featured_media_id + '"] img'
      );
      var target = this.mediaWrapper.querySelector('img');
      if (!source || !target) return;
 
      var srcset = source.getAttribute('srcset');
      if (srcset) {
        target.setAttribute('srcset', srcset);
        target.setAttribute('sizes', '80px');
        var fallback = source.getAttribute('src');
        if (fallback) target.src = fallback;
      } else if (source.currentSrc || source.src) {
        target.src = source.currentSrc || source.src;
        target.removeAttribute('srcset');
      }
    }

    updateAddButton(variant) {
      if (!this.addButton) return;
      var data = this.addButton.dataset;

      if (!variant) {
        this.addButton.disabled = true;
        if (this.addText) this.addText.textContent = data.textUnavailable || '';
        return;
      }

      this.addButton.disabled = !variant.available;
      if (this.addText) {
        this.addText.textContent = variant.available ? data.textAdd : data.textSoldout;
      }
    }

    handleSectionLoad(event) {
      if (!this.isConnected) return;
      if (event.detail && event.detail.sectionId) {
        var reloaded = String(event.detail.sectionId);
        if (reloaded !== String(this.dataset.sectionId)) return;
      }
      this.setup();
    }
  }

  if (!customElements.get('product-sticky-cart')) {
    customElements.define('product-sticky-cart', ProductStickyCart);
  }
})();